import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { downloadFile } from '../../../../../utils/files';
import { formatDate } from '../../../../../utils/formatacoes';
import CadastroProdutosService from '../../../../../Services/Cadastro/CadastroProdutosService';

const DocumentosTable = ({ documentos }) => {
  const [rows, setRows] = useState([]);

  const columns = [
    {
      id: 'nome',
      name: 'Nome',
      selector: (row) => row.nome,
    },
    {
      id: 'created',
      name: 'Data',
      selector: (row) => formatDate(row.created, false) ?? '-',
    },
    {
      name: 'Ações',
      id: 'actions',
      center: true,
      compact: true,
      width: '10vh',
      cell: (row) => (
        <i
          className='icofont icofont-download'
          onClick={() => handleDownloadClick(row.id)}
          style={{ fontSize: 20, cursor: 'pointer' }}
          title='Baixar documento'
        />
      ),
    },
  ];

  useEffect(() => {
    if (!documentos) return;

    const linhas = documentos.map((doc) => {
      return {
        id: doc.id,
        nome: doc.nome,
        created: doc.created,
      };
    });

    setRows(linhas);
  }, [documentos]);

  const handleDownloadClick = async (id) => {
    try {
      const fileData = await CadastroProdutosService.downloadDoc(id);

      if (fileData && fileData.file) {
        downloadFile(fileData);
      } else {
        toast.error('Erro ao fazer o download do arquivo.');
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Fragment>
      <DataTable dense columns={columns} data={rows} noDataComponent='Nenhum registro encontrado.' />
    </Fragment>
  );
};

export default DocumentosTable;
